import { Injectable } from '@angular/core';
import { catchError, retry } from 'rxjs/internal/operators';
import { Observable, throwError } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';
import { GlobalSearchService } from '../services/globalsearchservice.service';
@Injectable({
	providedIn: 'root'
})

export class DashboardService {
	key = 'UET6DFMPAXW7BKCB';
	config: any;
	user: any = [];
	package: any = '';

	constructor(private http: HttpClient, private _configSvc: RuntimeConfigLoaderService, public globalSearchService: GlobalSearchService) {
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		})

		this.globalSearchService.user.subscribe((result) => {
			this.user = result;
		});

	}

	public httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json',
		})
	};

	public getOptions = {
		headers: new HttpHeaders({

		})
	};

	public login(input) {
		localStorage.setItem('user', JSON.stringify(input));
		return true;
	}

	public logout() {
		localStorage.removeItem('user');
		return true;
	}

	public getDashBoard() {
		const method = 'dashboard' + this.getKey();
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	public getNegative() {
		const method = 'dashboard/negativeinv' + this.getKey();
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	public getNeedLocation() {
		const method = 'dashboard/needloc' + this.getKey();
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	public getTeamLeaderboard(datefrom?: string, dateto?: string, brands?: any[], categories?: any[], salespeople?: any[]) {
		let params = '';
		if (datefrom) { params += `&datefrom=${datefrom}`; }
		if (dateto)   { params += `&dateto=${dateto}`; }
		if (brands?.length)      { params += `&brands=${encodeURIComponent(brands.join(','))}`; }
		if (categories?.length)  { params += `&categories=${encodeURIComponent(categories.join(','))}`; }
		if (salespeople?.length) { params += `&salespeople=${encodeURIComponent(salespeople.join(','))}`; }
		const method = 'dashboard/teamleaderboard' + this.getKey() + params;
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	public getCatAndLines(days?: number) {
		const daysParam = days ? `&days=${days}` : '';
		const method = 'dashboard/getcatandlines' + this.getKey() + daysParam;
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}
	public getCatAndLinesPOS(days?: number) {
		const daysParam = days ? `&days=${days}` : '';
		const method = 'dashboard/getcatandlinespos' + this.getKey() + daysParam;
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	// ── Local-storage targets (interim until the backend fields land) ──────
	// Per Sean: persist targets in localStorage for now but keep the endpoints.

	private static readonly LOCAL_TARGETS_KEY = 'sales_targets_local';

	/** Raw local target map: '<type>:<key>:<period>' → amount. */
	public getLocalTargetMap(): Record<string, number> {
		try {
			return JSON.parse(localStorage.getItem(DashboardService.LOCAL_TARGETS_KEY)) || {};
		} catch (_) {
			return {};
		}
	}

	public saveLocalTarget(targetType: string, targetKey: string, period: string, amount: number): void {
		const map = this.getLocalTargetMap();
		const k = `${targetType}:${targetKey}:${period}`;
		if (amount > 0) {
			map[k] = amount;
		} else {
			delete map[k];
		}
		localStorage.setItem(DashboardService.LOCAL_TARGETS_KEY, JSON.stringify(map));
	}

	/** Resolve local targets to a period→amount map for this user: salesmen get
	 *  their own salesman targets, everyone else the sum of location targets. */
	public resolveLocalTargets(userdata: any): Record<string, number> {
		const map = this.getLocalTargetMap();
		const out: Record<string, number> = {};
		if (!userdata?.user) {
			// Widgets can load before the user subject emits — same source of truth.
			try { userdata = JSON.parse(localStorage.getItem('user')); } catch (_) { userdata = null; }
		}
		const issalesman = !!userdata?.user?.issalesman;
		const code = String(userdata?.user?.salesman ?? '');
		for (const k of Object.keys(map)) {
			const firstSep = k.indexOf(':');
			const lastSep = k.lastIndexOf(':');
			if (firstSep < 0 || lastSep <= firstSep) { continue; }
			const type = k.slice(0, firstSep);
			const key = k.slice(firstSep + 1, lastSep);
			const period = k.slice(lastSep + 1);
			const applies = issalesman ? (type === 'salesman' && key === code) : type === 'location';
			if (applies) {
				out[period] = (out[period] || 0) + (parseFloat(String(map[k])) || 0);
			}
		}
		return out;
	}

	/** Endpoint targets overlaid with any local edits (local wins until the backend fields exist). */
	public mergeLocalTargets(endpointTargets: any, userdata: any): Record<string, number> {
		// Guard: an unknown route can come back 200 with an HTML string — spreading
		// a string scatters characters into the map.
		const base = (endpointTargets && typeof endpointTargets === 'object' && !Array.isArray(endpointTargets))
			? endpointTargets
			: {};
		return { ...base, ...this.resolveLocalTargets(userdata) };
	}

	/** Current-month target out of a merged map, falling back to the endpoint value. */
	public currentMonthTarget(targets: Record<string, number>, fallback: any): number {
		const now = new Date();
		const period = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
		return targets?.[period] ?? (parseFloat(fallback) || 0);
	}

	/** Monthly sales targets applicable to the current user, keyed 'YYYY-MM'. */
	public getMySalesTargets() {
		const method = 'dashboard/mytargets' + this.getKey();
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	/** Raw target rows for the target editor. filters: { type, key, year } */
	public getSalesTargets(filters: any = {}) {
		const method = 'dashboard/gettargets' + this.getKey()
			+ '&type=' + encodeURIComponent(filters.type || '')
			+ '&type_key=' + encodeURIComponent(filters.key ?? '')
			+ '&year=' + encodeURIComponent(filters.year || '');
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	/** Upsert one monthly target: { target_type, target_key, period, target_amount } */
	public saveSalesTarget(data: any) {
		const method = 'dashboard/savetarget' + this.getKey();
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public getThisYearOverLast(filters: any = {}) {
		const method = 'dashboard/thisoverlast' + '&yearCount=' + filters.yearCount + this.getKey();
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	public getThisYearOverLastSalesman(data: any) {
		const method = 'dashboard/thisoverlast' + this.getKey();
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public getThisMonthOverLast(data) {
		const method = 'dashboard/daybyday';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public getThisDayOverLast(data) {
		const method = 'dashboard/daysales';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public getSalesmanData(data:any) {
		const method = 'salesman/dashboard' + this.getKey();
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public getSalesmanKpis(period?: { kpis_primary_ym: string; kpis_compare_ym: string } | null) {
		let method = 'dashboard/salesmankpis' + this.getKey();
		if (period?.kpis_primary_ym && period?.kpis_compare_ym) {
			method += '&kpis_primary_ym=' + encodeURIComponent(period.kpis_primary_ym)
				+ '&kpis_compare_ym=' + encodeURIComponent(period.kpis_compare_ym);
		}
		return this.http.get(this.setEndPoint(method), this.getOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public getOpenCOunt() {
		const method = 'dashboard/openorders' + this.getKey();
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	/**
	 * Splits a canonical open-order list into age buckets (days since
	 * DATE_ORDERED) and a "not due" bucket (DATE_WANTED is today or later).
	 *   bucket1: 3-5 days old
	 *   bucket2: 5-7 days old
	 *   bucket3: >7 days old
	 *   notdue:  DATE_WANTED in the future (or today), deduped by orderno
	 */
	public computeOpenOrderAgeBuckets(rows: any[]): { bucket1: any[]; bucket2: any[]; bucket3: any[]; notdue: any[] } {
		const bucket1: any[] = [];
		const bucket2: any[] = [];
		const bucket3: any[] = [];
		const notdue: any[] = [];
		const notdueSeen = new Set<any>();

		const now = new Date();
		const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
		const msPerDay = 1000 * 60 * 60 * 24;

		const parseDate = (raw: any): Date | null => {
			if (!raw) { return null; }
			if (typeof raw === 'string') {
				const normalized = raw.replace(' ', 'T');
				const d = new Date(normalized);
				if (!isNaN(d.getTime())) { return d; }
				const d2 = new Date(raw);
				return isNaN(d2.getTime()) ? null : d2;
			}
			const d = new Date(raw);
			return isNaN(d.getTime()) ? null : d;
		};

		for (const row of rows) {
			const ordered = parseDate(row.DATE_ORDERED || row.orddate || row.date_created);
			if (ordered) {
				const orderedDay = new Date(ordered.getFullYear(), ordered.getMonth(), ordered.getDate()).getTime();
				const daysOld = Math.floor((today - orderedDay) / msPerDay);
				if (daysOld >= 3 && daysOld < 5) {
					bucket1.push(row);
				} else if (daysOld >= 5 && daysOld < 7) {
					bucket2.push(row);
				} else if (daysOld >= 7) {
					bucket3.push(row);
				}
			}

			const wanted = parseDate(row.DATE_WANTED || row.deliverydate);
			if (wanted) {
				const wantedDay = new Date(wanted.getFullYear(), wanted.getMonth(), wanted.getDate()).getTime();
				if (wantedDay >= today) {
					const key = row.orderno ?? row.ORDER_NUMBER;
					if (key !== undefined && !notdueSeen.has(key)) {
						notdueSeen.add(key);
						notdue.push(row);
					} else if (key === undefined) {
						notdue.push(row);
					}
				}
			}
		}

		return { bucket1, bucket2, bucket3, notdue };
	}

	public getOrderCountByDay() {
		const method = 'dashboard/getordercountbyday' + this.getKey();
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	public getReceievedTotalByDay() {
		const method = 'dashboard/getposcountbyday' + this.getKey();
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	public getTaxOrders() {
		const method = 'dashboard/gettaxorders' + this.getKey();
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	public getNonStockData(label) {
		const method = 'dashboard/getnonstocks' +'&label='+ label + this.getKey();
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	public getScoreboard(data){
		const method = 'dashboard/scoreboard';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('scoreboard', data))
		)
	}

	private setEndPoint(method: any) {
		return this.getApi() + method + this.getApiKey()
	}

	private getApi() {
		return this.config.apiServer.endpoint;
	}

	private getApiKey() {
		return '&key=' + this.config.apiCredentials.clientId + '&userid=' + this.user.user.userid + this.getPackage();
	}

	public getBrandReport(data:any) {		
		const method = data.vendor ? 'dashboard/vendorbrandbylocation' : 'dashboard/brandbylocation';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	private getPackage() {
		const p = this.globalSearchService.getSessionItem('package');
		if(p) {
			return '&package='+p;
		} else {
			return '';
		}
	}

	public getKey() {
		return '&apikey=' + this.key;
	}

	private handleError<T>(operation = 'operation', result?: T) {

		return (error: any): Observable<T> => {

			if (error instanceof HttpErrorResponse && error.status === 401) {
				window.location.href = '/#/auth/logout';
			}

			return throwError(() => error);
		};
	}

}
